export default "__VITE_ASSET__99479068__"